import { render, staticRenderFns } from "./AboutPc.vue?vue&type=template&id=619b6f03&scoped=true&"
import script from "./AboutPc.vue?vue&type=script&lang=js&"
export * from "./AboutPc.vue?vue&type=script&lang=js&"
import style0 from "./AboutPc.vue?vue&type=style&index=0&id=619b6f03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619b6f03",
  null
  
)

export default component.exports